import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAivTG1sWt7VwpVM2fZ_JUHuVBQG_EET-8",
  authDomain: "vethelper-356b1.firebaseapp.com",
  databaseURL: "https://vethelper-356b1-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "vethelper-356b1",
  storageBucket: "vethelper-356b1.firebasestorage.app",
  messagingSenderId: "374164250966",
  appId: "1:374164250966:web:6006e8c75d78707193b6f7" 
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Servisleri tanımla
export const auth = getAuth(app);
export const db = getDatabase(app);        // Realtime Database (Mevcut users kaydı için)
export const firestore = getFirestore(app); // Firestore (Yeni history3 kaydı için)